interface BASE_TAG {
    name?: string;
    key: string;
    disabled?: boolean;
}

interface LABEL_TAG extends BASE_TAG{
    type: 'label';
    args: [string, string, boolean?];
}

interface COUNTER_TAG extends BASE_TAG {
    type: 'counter';
    args: [string, number];
}

interface BUTTON_COUNTER_TAG extends BASE_TAG {
    type: 'buttonCounter';
    args: [string, number, string, boolean];
}

interface NOTIFICATION_LABEL_WITH_COUNTER_TAG extends BASE_TAG {
    type: 'notificationLabelWithCounter';
    args: [string, number, string, string?, string?];
}

interface NOTIFICATION_LABEL_TAG extends BASE_TAG {
    type: 'notificationLabel';
    args: [string, string?, string?];
}

interface BUTTON_GROUP_TAG extends BASE_TAG {
    type: 'buttonGroup';
    args: [string, string, string, string];
}

interface SWITCHER_TAG extends BASE_TAG {
    type: 'switcher';
    args: [string, string, string, string];
}

interface CLOSE_ICON_TAG extends BASE_TAG {
    type: 'closeIcon';
    args: [number, (e: React.MouseEvent<HTMLAnchorElement>, index: number) => void, string];
}

export type CUSTOM_TAG_PROPS = LABEL_TAG
    | COUNTER_TAG
    | BUTTON_COUNTER_TAG
    | NOTIFICATION_LABEL_WITH_COUNTER_TAG
    | NOTIFICATION_LABEL_TAG
    | BUTTON_GROUP_TAG
    | SWITCHER_TAG
    | CLOSE_ICON_TAG

export enum CustomTagType {
    counter = 'counter',
    buttonCounter = 'buttonCounter',
    label = 'label',
    notificationLabel = 'notificationLabel',
    notificationLabelWithCounter = 'notificationLabelWithCounter',
    buttonGroup = 'buttonGroup',
    switcher = 'switcher',
    closeIcon = 'closeIcon'
}
